import { PRODUCT_LECTURA, PRODUCT_READING } from 'root/lib/constants';
import gameIds from '../../hub/data/GameIds';

export const GAME_ID = gameIds.SKILL_SCAN;
export const GAME_ID_ES = `${GAME_ID}_es`;
export const AGGREGATE_ID_ES = `${gameIds.SKILL_SCAN_AGGREGATE}_es`; // only applies to lectura

export const MEASURE_TYPES = {
  MIND_THE_GAP: gameIds.MIND_THE_GAP,
  REAL_WORD_READING: gameIds.REAL_WORD_READING,
  LETTER_SOUND_CORRESPONDENCES: gameIds.LETTER_SOUND_CORRESPONDENCES,
  SYLLABLE_DECODING: gameIds.SYLLABLE_DECODING,
};

export const SCREENS = {
  LOADING: 'loading',
  POPUP: 'popup',
  INTRO: 'intro',
  MEASURE: 'measure',
  RESULTS: 'resuts',
  INTERSTITIAL: 'interstitial',
};

export const ACTIONS = {
  SET_SKILL_SCAN_MEASURES: 'SET_SKILL_SCAN_MEASURES',
  SET_SKILL_SCAN_ACTIVITY: 'SET_SKILL_SCAN_ACTIVITY',
  SET_SKILL_SCAN_REDIRECT_FLAG: 'SET_SKILL_SCAN_REDIRECT_FLAG',
  SET_SKILL_SCAN_REDIRECT_HARDCODED: 'SET_SKILL_SCAN_REDIRECT_HARDCODED',
  SET_SKILL_SCAN_LAST_TIME_PLAYED: 'SET_SKILL_SCAN_LAST_TIME_PLAYED',
  SET_SKILL_SCAN_MEASURE_COMPLETE: 'SET_SKILL_SCAN_MEASURE_COMPLETE',
  SET_SKILL_SCAN_AGGREGATE_SCORE: 'SET_SKILL_SCAN_AGGREGATE_SCORE',
  SET_SKILL_SCAN_PASSAGE: 'SET_SKILL_SCAN_PASSAGE',
  SET_SKILL_SCAN_FORM: 'SET_SKILL_SCAN_FORM',
  SET_SKILL_SCAN_SD_FORM: 'SET_SKILL_SD_SCAN_FORM',
  SET_SKILL_SCAN_LSC_FORM: 'SET_SKILL_LSC_SCAN_FORM',
  SET_SKILL_SCAN_SESSION_DATA: 'SET_SKILL_SCAN_SESSION_DATA',
  SET_SHOULD_DISPLAY_AMP_GLOBAL_NAV: 'SET_SHOULD_DISPLAY_AMP_GLOBAL_NAV',
  CLEAR_TEACHER_RESET_INFO: 'CLEAR_TEACHER_RESET_INFO',
};

export const CURIOSO_SKIN = {
  FURRY: 'furry',
  FEATHERY: 'feathery',
  SCALY: 'scaly',
};
export const SAVED_DATA_VERSION = '3.0';

export const PERCENTILE_BOUNDS_BY_PRODUCT = {
  [PRODUCT_READING]: {
    lowerBound: 40,
    upperBound: 60,
  },
  [PRODUCT_LECTURA]: {
    lowerBound: 40,
    upperBound: 80,
  },
};
export const PERFORMANCE_STRING_1 = 'Working Below Grade Level';
export const PERFORMANCE_STRING_2 = 'Working on Grade Level';
export const PERFORMANCE_STRING_3 = 'Working Above Grade Level';
export const PERFORMANCE_TO_STARS_MAP = {
  [PERFORMANCE_STRING_1]: 1,
  [PERFORMANCE_STRING_2]: 2,
  [PERFORMANCE_STRING_3]: 3,
};
